<template>
  <div class="container-fluid" @touchstart="taphandler">
    <div class="row" v-if="popularStatus">
      <div id="combos" class="popular-Titles">
        {{ $t("message.popular") }}
        <a v-on:click="setVisibility(false)">{{ $t("message.skip") }}</a>
      </div>
      <section class="popular" @touchstart.stop>
        <div style="display: inline-flex">
          <div
            class="productItem"
            v-for="item in getPopulars()"
            :key="item.ProductID"
          >
            <PopularProduct
              :product="storeMenu.Products[item.ProductID]"
              :modifiers="storeMenu.ModifierGroups"
              :category="item"
              :key="item.ProductID"
              :parent-category="{ ID: '0', Name: 'popular' }"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import PopularProduct from "../products/PopularProductMobile";

export default {
  name: "ShopPopulars",
  components: {
    PopularProduct,
  },
  data() {
    return {
      popularStatus: true,
      lastTapTimestamp: null,
    };
  },
  computed: {
    ...mapGetters([
      "getPopularStatus",
      "getProductFromCategories",
      "storeMenu",
    ]),
  },
  methods: {
    ...mapMutations(["setPopularStatus"]),
    taphandler() {
      const now = new Date().getTime();
      const delta = now - this.lastTapTimestamp;
      if (delta < 500 && delta > 0) {
        event.preventDefault();
      }

      this.lastTapTimestamp = now;
    },
    setVisibility(isVisible) {
      this.popularStatus = isVisible;
      this.setPopularStatus(isVisible);
      this.$emit("show-popular", this.popularStatus);
    },
    getPopulars() {
      this.popularStatus = this.getPopularStatus;
      if (this.popularStatus) {
        const popularProducts = Object.entries(this.storeMenu.Products)
          .map(([key, value]) => {
            return { ...value, ProductID: key };
          })
          .filter(
            (p) => p.Status === 2 && this.getProductFromCategories(p.ProductID)
          );

        this.setVisibility(popularProducts.length > 0);

        return popularProducts.map((m) =>
          this.getProductFromCategories(m.ProductID)
        );
      } else {
        this.$emit("show-popular", this.popularStatus);
        return null;
      }
    },
  },
};
</script>
<style scoped>
.container-fluid {
  padding: 0;
}
.popular::-webkit-scrollbar {
  display: none;
}
.popular:first-child {
  margin-left: 0px;
}
.popular {
  height: 220px;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.productItem {
  height: 205px;
  width: 120px;
  margin-top: 10px;
  float: left;
  margin-left: 10px;
  font-size: 10px;
  position: relative;
}
.popular-Titles {
  width: 100%;
  margin: 15px 15px 0 15px;
}
.popular-Titles a {
  float: right;
}
</style>
